/**
 * Widget V2 - LoadingSpinner Component
 *
 * Centered loading indicator with optional message.
 */

import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

/**
 * LoadingSpinner component
 *
 * @param {Object} props
 * @param {string} props.message - Optional loading message
 * @param {string} props.size - Size: 'small' | 'medium' | 'large'
 * @param {boolean} props.fullPage - Center in full viewport
 * @param {boolean} props.overlay - Show as overlay
 */
function LoadingSpinner({
  message,
  size = "medium",
  fullPage = false,
  overlay = false
}) {
  const sizeMap = {
    small: 24,
    medium: 40,
    large: 56
  };

  const content = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        p: 3
      }}
    >
      <CircularProgress size={sizeMap[size]} />
      {message && (
        <Typography variant="body2" color="textSecondary">
          {message}
        </Typography>
      )}
    </Box>
  );

  if (fullPage) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh"
        }}
      >
        {content}
      </Box>
    );
  }

  if (overlay) {
    return (
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "rgba(255, 255, 255, 0.8)",
          zIndex: 10
        }}
      >
        {content}
      </Box>
    );
  }

  return content;
}

export default LoadingSpinner;
